<template>
  <div>
    <div v-if="disabled">
      <h3>{{ $t('YEAR_CHECK.FORBIDDEN.TITLE') }}</h3>
      <p class="my-2">
        {{ $t('YEAR_CHECK.FORBIDDEN.SUBTITLE') }}
      </p>
    </div>
    <div v-else>
      <form ref="form">
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <!-- <template v-slot:activator> -->
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :label="$t('YEAR_CHECK.PLACEHOLDER')"
              :rules="[yearRules]"
              type="number"
              v-bind="attrs"
              v-on="on"
              v-model="date"
              max="4"
              ref="yearField"
            ></v-text-field>
          </template>
          <v-date-picker
            ref="picker"
            :max="new Date().toISOString().substr(0, 10)"
            min="1920-01-01"
            @click:year="setYear"
          ></v-date-picker>
        </v-menu>
      </form>
<!--
      <p class="px-2">
        <BaseButton
          :disabled="!date"
          @click="check()"
        >
          {{ $t('YEAR_CHECK.CHECK') }}
        </BaseButton>
      </p> -->
    </div>
  </div>
</template>

<style scoped>
>>>.v-picker__title {
  display: none;
}
</style>

<script>
const MIN_AGE = 14;

export default {
  name: 'YearSelector.vue',
  props: {
    year: {
      type: Number,
      default: -1,
    },
  },
  data: () => ({
    date: null,
    menu: false,
    disabled: false,
  }),
  computed: {
    showModal() {
      const { isLogged } = this.$store.state.session;
      const { year } = this.$store.state.settings;
      if (isLogged && (!year || !this.canPlay(year))) {
        return true;
      }

      return false;
    },
    yearRules() {
      const v = this.date;
      if (!v) {
        return this.$t('REGISTER.ERROR_FIELD_MANDATORY');
      }

      if (v.length > 4) {
        return this.$t('REGISTER.ERROR_YEAR_LONG');
      }

      const today = new Date();
      if (v > today.getFullYear()) {
        return this.$t('REGISTER.ERROR_YEAR_FUTURE');
      }

      return true;
    },
  },
  methods: {
    setYear(date) {
      this.date = date;
      this.$refs.menu.save(date);
    },
    check() {
      if (!this.date || !this.canPlay(this.date)) {
        return false;
      }

      return true;
    },
    canPlay(date) {
      if (this.yearRules !== true) {
        return false;
      }

      const year = new Date().getFullYear();
      if (date < 1920 && year - date < MIN_AGE) {
        return false;
      }
      return true;
    },
  },
  created() {
    if (this.year > -1) {
      this.setYear(this.year);
    }
  },
  watch: {
    menu(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.picker.activePicker = 'YEAR';
        });
      }
    },
    date() {
      this.$emit('input', this.date);
    },
  },
};
</script>
